<template>
  <div v-if="preview && format" class="relative">
    <div v-if="['application/pdf', 'pdf'].includes(format)" :class="`position-relative ${previewPdf ? 'pdf-preview' : '' }`">
      <template v-if="previewPdf">
        <button class="btn btn-link" @click="openPreview" target="_blank">{{ $t("See Detail") }}</button>
        <object
          class="mt-1"
          :data="preview"
          type="application/pdf"
          width="100%"
          height="500px"
        ></object>
      </template>
      <button v-else class="btn btn-primary" @click="openPreview" style="width: 100%" target="_blank" v-b-tooltip.hover :title="originalFilename">{{ fileName }}</button>
      <div class="button-close" v-if="deletable" @click="$event => $emit('delete')">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 11H5V9H15M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z" fill="#DC1021"/>
        </svg>
      </div>
    </div>
    <div class="relative" v-else >
      <template v-if="previewImage">
        <image-preview-modal v-bind="$props" :id="_uid" />
        <b-img 
          thumbnail 
          fluid
          :style="imageStyle"
          :src="preview" 
          @click="$bvModal.show(_uid)"
          role="button"
        >
        </b-img>
      </template>
      <button v-else class="btn btn-primary" @click="openPreview" style="width: 100%" target="_blank" v-b-tooltip.hover :title="originalFilename">{{ fileName }}</button>
      <div class="button-close" v-if="deletable" @click="$event => $emit('delete')">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 11H5V9H15M10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z" fill="#DC1021"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import ImagePreviewModal from '@/components/modals/image-preview-modal';
export default {
  name: "preview-image-pdf",
  components: {
    ImagePreviewModal,
  },
  props: {
    preview: String,
    format: String,
    imageStyle: {
      type: String,
      default: "height: 200px; width: 200px; object-fit: contain;",
    },
    deletable: Boolean,
    previewPdf: {
      type: Boolean,
      default: true,
    },
    previewImage: {
      type: Boolean,
      default: true,
    },
    file: {
      default: undefined
    }
  },
  computed: {
    isBase64(){
      return this.preview.includes("data:");
    },
    originalFilename(){
      if(this.file?.file?.name){
        return this.file?.file?.name
      }
      const filename = this.preview.split("/").pop();
      let cleanFilename = filename.split("?")[0];
      return cleanFilename;
    },
    fileName(){
      const maxLength = 24;
      let cleanFilename = this.originalFilename;
      if(cleanFilename.length > maxLength){
        cleanFilename = cleanFilename.slice(0, maxLength)+'...';
      }
      return cleanFilename;
    }
  },
  methods: {
    openPreview() {
      if(!this.isBase64) {
        window.open(this.preview, "_blank");
      }
      let [header, base64data] = this.preview.split(",");
      let mime = header.match(/:(.*?);/)[1];
      let blob = new Blob(
        [
          new Uint8Array(
            atob(base64data)
              .split("")
              .map((c) => c.charCodeAt(0))
          ),
        ],
        { type: mime }
      );
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
      }
      this.objectUrl = URL.createObjectURL(blob);
      open(this.objectUrl);
    },
  },
};
</script>

<style scoped lang="scss">
  .button-close {
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 50%;
    padding: 5px;
    cursor: pointer;
  }

  .pdf-preview {
    .button-close {
      top: 24px;
      right: -10px;
    }
  }
</style>